/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { errorResponseSchema } from "../errorResponseSchema.ts";
import { organizationMemberListItemSchema } from "../organizationMemberListItemSchema.ts";
import { z } from "zod";

export const getUserOrganizationsMembersHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application pour lequel récupérer les informations utilisateur.")
      })

/**
 * @description La liste des membres est retournée avec succès.
 */
export const getUserOrganizationsMembers200Schema = z.array(z.lazy(() => organizationMemberListItemSchema))

/**
 * @description Réponse d\'erreur standard
 */
export const getUserOrganizationsMembers500Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const getUserOrganizationsMembersQueryResponseSchema = z.lazy(() => getUserOrganizationsMembers200Schema)